import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../../pages/Login/Login.jsx';
import Error from '../../pages/Error/Error.jsx';
import Footer from '../MainLayout/Footer/Footer.jsx';
import { useIsLogin } from '../../hooks/useIsLogin.js';
import Waiting from '../Waiting.jsx';
import ForgotPassword from '../../pages/ForgotPassword/ForgotPassword.jsx';

const AuthLayout = () => {
    const [isLogin, isLoading] = useIsLogin();

    return isLoading ? (
        <Waiting />
    ) : isLogin ? (
        <Navigate to="/" />
    ) : (
        <div className="auth-container fixed top-0 left-0
        w-full h-screen overflow-auto">
            <div className="div-auth py-14 px-6 sm:px-0 xl:px-8">
                <main className="custom-box-shadow container mx-auto 
                    max-w-screen-md bg-color py-6 px-4 md:px-8 
                    rounded-lg">
                    <Routes>
                        <Route path="/auth/login" element={<Login />} />
                        {/* <Route path="/auth/forgot-password" element={<ForgotPassword />} /> */}
                        <Route path="/auth/*" element={<Error />} />
                    </Routes>
                </main>
            </div>
            <Footer />
        </div>
    );
}

export default AuthLayout;
